export const EmailValidators = (value) => {
  // eslint-disable-next-line
  const gex = new RegExp("[a-z0-9]+@[a-z0-9]+.[a-z]{2,3}");
  return !gex.test(value);
};

export const PhoneValidators = (value) => {
  /* eslint-disable */
  const gex =
    /^[\+]?[0-9]{0,2}[-\s\.]?[0-9]{3}?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3}$/;
  return !gex.test(value);
  /* eslint-disable */
};

export const passwordValidator = (value) => {
  // eslint-disable-next-line
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{12,}$/;
  return passwordRegex.test(value);
};

export const validateNIP = (nip) => {
  // Usuń myślniki i białe znaki
  if (!nip) {
    return;
  }
  nip = nip.replace(/[-\s]/g, "");

  // Sprawdź, czy NIP ma dokładnie 10 cyfr
  if (!/^\d{10}$/.test(nip)) {
    return false;
  }

  // Wagi do obliczenia sumy kontrolnej
  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];

  // Oblicz sumę kontrolną
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += nip[i] * weights[i];
  }

  // Oblicz cyfrę kontrolną
  const controlDigit = sum % 11;
  if (controlDigit === 10) {
    return false;
  }

  // Sprawdź, czy cyfra kontrolna jest poprawna
  return controlDigit === parseInt(nip[9], 10);
};
